// extracted by mini-css-extract-plugin
export var buttons = "_2w-0";
export var buttonsActive = "_2w-h";
export var cancelConfirm = "_2w-1";
export var closeButton = "_2w-2";
export var column = "_2w-3";
export var container = "_2w-4";
export var detailHeader = "_2w-6";
export var detailTitle = "_2w-7";
export var detailsContent = "_2w-5";
export var header = "_2w-8";
export var headerWithClose = "_2w-9";
export var icon = "_2w-a";
export var infoIcon = "_2w-c";
export var informationContainer = "_2w-b";
export var sideDrawer = "_2w-d";
export var sideDrawerOpen = "_2w-e";
export var stickyFooter = "_2w-f";
export var typeOption = "_2w-g";